import axios from "axios";

const axiosInstance = (method, url, data, params, type, baseUrl, auth) => {
    const contentType = type ? type : 'application/x-www-form-urlencoded';

    const accessToken = 'Bearer ' + localStorage.getItem('sessionToken');
    const headers = {
        'content-type': contentType,
        Authorization: accessToken,
    };

    let config = {
        method: method ? method : 'GET',
        baseURL: baseUrl ? baseUrl : '',
        url: url ? url : '',
        headers: headers,
        data: data ? data : null,
        params: params ? params : null,
        auth: auth ? auth : null
    };

    
    return axios(config);

};

export default axiosInstance;
